import tr from './tr.json';
import en from './en.json';
import keywords from './keywords';

export const dictionaryList = {
  tr,
  en,
};

export const languageOptions = {
  english: 'en',
  turkey: 'tr',
};

export const langOptions = {
  english: 'en-US',
  turkey: 'tr-TR',
};

export const languageKeywords = keywords;
